import React, { useState, useEffect } from "react";
import { doctorJson } from "../../api/DoctorApi";
import SearchBar from "./searchBar/SearchBar";
import List from "./List";
import EmptyView from "./empty/EmptyView";
import FilterPanel from "./filterPanel/FilterPanel";
import "./query.css";

const DocMain = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState([1, 10]);
  const [cuisines, setCuisines] = useState([
    { id: 1, checked: false, label: "ENT" },
    { id: 2, checked: false, label: "Gynecologist" },
    { id: 3, checked: false, label: "Urologist" },
    { id: 4, checked: false, label: "Orthopedic" },
    { id: 5, checked: false, label: "Cardiologist" },
    { id: 6, checked: false, label: "Surg" },
  ]);

  const [list, setList] = useState(doctorJson);
  const [resultsFound, setResultsFound] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const handleSelectCategory = (event, value) =>
    !value ? null : setSelectedCategory(value);
  const handleChangeChecked = (id) => {
    const cuisinesStateList = cuisines;
    const changeCheckedCuisines = cuisinesStateList.map((item) =>
      item.id === id ? { ...item, checked: !item.checked } : item
    );
    setCuisines(changeCheckedCuisines);
  };
  const handleChangePrice = (event, value) => {
    setSelectedPrice(value);
  };
  const applyFilters = () => {
    let updatedList = doctorJson;
    // Category Filter
    if (selectedCategory) {
      updatedList = updatedList.filter(
        (item) => item.category === selectedCategory
      );
    }
    // Cuisine Filter
    const cuisinesChecked = cuisines
      .filter((item) => item.checked)
      .map((item) => item.label.toLowerCase());

    if (cuisinesChecked.length) {
      updatedList = updatedList.filter((item) =>
        cuisinesChecked.includes(item.cuisine)
      );
    }
    // Search Filter
    if (searchInput) {
      updatedList = updatedList.filter(
        (item) =>
          item.title.toLowerCase().search(searchInput.toLowerCase().trim()) !==
          -1
      );
    }
    // Price Filter
    const minPrice = selectedPrice[0];
    const maxPrice = selectedPrice[1];

    updatedList = updatedList.filter(
      (item) => item.price >= minPrice && item.price <= maxPrice
    );

    setList(updatedList);

    !updatedList.length ? setResultsFound(false) : setResultsFound(true);
  };
  useEffect(() => {
    applyFilters();
  }, [selectedCategory, cuisines, searchInput, selectedPrice]);
  return (
    <div>
      <div className="wrapper">
        <div className="filter-box">
          <FilterPanel
            cuisines={cuisines}
            selectCategory={handleSelectCategory}
            changeChecked={handleChangeChecked}
            selectedPrice={selectedPrice}
            changePrice={handleChangePrice}
          />
        </div>
        <div className="container-doc-list">
          <span className="doc-list">
            <h2 className="doc-list-h2">Showing 1-6 of 21 Results</h2>
            <SearchBar
              className="doc-list-search"
              value={searchInput}
              changeInput={(e) => setSearchInput(e.target.value)}
            />
          </span>
          {resultsFound ? <List list={list} /> : <EmptyView />}
        </div>
      </div>
    </div>
  );
};

export default DocMain;
